/* ZSportsTech — variant-picker.js
   Modal variant picker for add-ons bought from outside their own PDP (e.g.
   picking one of 24 Bat Grip variants from a bat page). Fetches the Ajax
   API product payload, adapts it to the normalised shape expected by
   assets/variant-select.js, and renders through that SAME engine so the
   popup can never drift from the accessory PDP's variant selector.

   Public API: window.SCVariantPicker.open(handle, onPick)
     - onPick(variantId) is called once a valid, in-stock variant is chosen
       and "Add to cart" is pressed.
     - onPick(null) is called if the user cancels (X / overlay / Escape)
       without picking.
   The picker never adds to cart itself — the caller decides what to do
   with the chosen variant id.
   ─────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }

  function formatMoney(cents) {
    if (window.SCCart && typeof window.SCCart.format === 'function') return window.SCCart.format(cents);
    return '₹' + Math.round(cents / 100);
  }

  /* Adapt an Ajax API (/products/<handle>.js) payload to the normalised
     shape { optionNames, variants:[{id,opts,price,available,img}] }. */
  function adapt(data) {
    var productImg = data.featured_image || (data.images && data.images[0]) || null;
    return {
      title: data.title,
      /* The Ajax API returns options as OBJECTS ({name, values, position}); SC_ACC on the
         accessory PDP returns plain strings. The engine wants strings — isColourOption()
         regex-tests the name, so an object here silently degrades every colour swatch into
         a text pill and the picker stops matching the PDP. Normalise both shapes. */
      optionNames: (data.options || []).map(function (o) {
        return (o && typeof o === 'object') ? o.name : o;
      }),
      variants: (data.variants || []).map(function (v) {
        var img = (v.featured_image && v.featured_image.src) || productImg;
        return {
          id: v.id,
          opts: v.options || [],
          price: formatMoney(v.price),
          available: !!v.available,
          img: img
        };
      })
    };
  }

  var engine = null;
  var currentOnPick = null;
  var lastFocused = null;

  var elOverlay, elModal, elClose, elTitle, elImg, elPh, elPrice, elOptions, elError, elAdd;

  function bindEls() {
    elOverlay = $('scvp-overlay');
    elModal = $('scvp-modal');
    elClose = $('scvp-close');
    elTitle = $('scvp-title');
    elImg = $('scvp-img');
    elPh = $('scvp-ph');
    elPrice = $('scvp-price');
    elOptions = $('scvp-options');
    elError = $('scvp-error');
    elAdd = $('scvp-add');
  }

  function focusable() {
    if (!elModal) return [];
    return Array.prototype.slice.call(
      elModal.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { cancel(); return; }
    if (e.key === 'Tab') {
      var f = focusable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function showModal() {
    elModal.hidden = false;
    elOverlay.hidden = false;
    requestAnimationFrame(function () {
      elModal.classList.add('is-open');
      elOverlay.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    lastFocused = document.activeElement;
    if (elClose) elClose.focus();
  }

  function hideModal() {
    elModal.classList.remove('is-open');
    elOverlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    window.setTimeout(function () {
      elModal.hidden = true;
      elOverlay.hidden = true;
    }, 280);
    if (engine) { engine.destroy(); engine = null; }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function cancel() {
    var cb = currentOnPick;
    currentOnPick = null;
    hideModal();
    if (typeof cb === 'function') cb(null);
  }

  function showError(msg) {
    elOptions.innerHTML = '';
    elError.textContent = msg;
    elError.hidden = false;
    elAdd.disabled = true;
    elAdd.textContent = 'Unavailable';
  }

  function renderProduct(product) {
    elError.hidden = true;
    elTitle.textContent = product.title || '';

    var chosen = null;

    function onChange(variant) {
      chosen = variant;
      if (!variant) {
        elAdd.disabled = true;
        elAdd.textContent = 'Select options';
        return;
      }
      elPrice.textContent = variant.price;
      if (variant.img) {
        elImg.src = variant.img;
        elImg.hidden = false;
        elPh.hidden = true;
      } else {
        elImg.hidden = true;
        elPh.hidden = false;
      }
      if (variant.available) {
        elAdd.disabled = false;
        elAdd.textContent = 'Add to cart';
      } else {
        elAdd.disabled = true;
        elAdd.textContent = 'Sold out';
      }
    }

    engine = window.SCVariantSelect.create(elOptions, product, onChange);

    elAdd.onclick = function () {
      if (!chosen || !chosen.available) return;
      var cb = currentOnPick;
      var id = chosen.id;
      currentOnPick = null;
      hideModal();
      if (typeof cb === 'function') cb(id);
    };
  }

  /* Product JSON, keyed by handle. The repair page reopens the same add-on over and
     over ("a different grip"), and a cached product renders synchronously — no fetch,
     no skeleton, no flash at all. */
  var cache = {};

  function setLoading(on) {
    if (on) { elModal.setAttribute('data-loading', 'true'); }
    else { elModal.removeAttribute('data-loading'); }
  }

  function open(handle, onPick) {
    bindEls();
    if (!elOverlay || !elModal) return;

    currentOnPick = onPick;
    elImg.hidden = true;
    elPh.hidden = false;
    elPrice.textContent = '';
    elOptions.innerHTML = '';
    elError.hidden = true;
    elAdd.disabled = true;
    elAdd.textContent = 'Select options';
    elTitle.textContent = '';

    /* Already fetched: paint the real thing immediately, skeleton never shows. */
    if (cache[handle]) {
      setLoading(false);
      showModal();
      renderProduct(cache[handle]);
      return;
    }

    /* First time: the fetch happens AFTER the modal opens, so show the skeleton
       instead of an empty shell. */
    setLoading(true);
    showModal();

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      })
      .then(function (data) {
        var product = adapt(data);
        if (!product.variants.length) {
          setLoading(false);
          showError('This product has no purchasable variants.');
          return;
        }
        cache[handle] = product;
        setLoading(false);
        renderProduct(product);
      })
      .catch(function () {
        setLoading(false);
        showError('Sorry, we could not load the options for this product. Please try again.');
      });
  }

  function init() {
    bindEls();
    if (!elOverlay || !elModal) return;
    elClose.addEventListener('click', cancel);
    elOverlay.addEventListener('click', cancel);
  }

  window.SCVariantPicker = { open: open };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
